import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    Chip,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    SwipeableDrawer,
    Typography
} from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRightOutlined';
import Close from '@material-ui/icons/CloseOutlined';
import TextButton from '../../../shared/buttons/TextButton';

const useStyles = makeStyles(theme => ({
    paper: {
        borderTopLeftRadius: theme.shape.borderRadius * 3,
        borderTopRightRadius: theme.shape.borderRadius * 3,
        paddingBottom: `env(safe-area-inset-bottom)`
    },
    puxador: {
        width: theme.spacing(4.5),
        height: theme.spacing(0.5),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.divider,
        margin: theme.spacing(1.5, 'auto', 0)
    },
    cabecalho: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        padding: theme.spacing(1.5, 1, 1, 2)
    },
    rodape: {
        padding: theme.spacing(1, 2)
    },
    lista: {
        paddingTop: 0,
        paddingBottom: 0
    },
    item: {
        minHeight: theme.spacing(7),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    icone: {
        minWidth: theme.spacing(5.5),
        color: theme.palette.tertiary.main
    },
    descricaoAviso: {
        color: theme.palette.error.main
    },
    contador: {
        marginRight: theme.spacing(1),
        height: 22,
        backgroundColor: theme.palette.error.main,
        color: theme.palette.common.white,
        fontWeight: 700
    },
    seta: {
        color: theme.palette.text.secondary
    }
}));

/*
 * Folha inferior com as ações da inscrição. No mobile substitui a fileira de
 * botões: um toque abre a lista, e o gesto de arrastar para baixo fecha.
 */
export default function SheetAcoesInscricao({
    aberto = false,
    onFechar,
    onAbrir,
    titulo = 'Alterar minha inscrição',
    descricao,
    acoes = []
}) {
    const classes = useStyles();

    return (
        <SwipeableDrawer
            anchor="bottom"
            open={aberto}
            onClose={onFechar}
            onOpen={onAbrir || (() => {})}
            disableDiscovery
            disableBackdropTransition
            classes={{ paper: classes.paper }}>
            <div className={classes.puxador} />

            <div className={classes.cabecalho}>
                <div>
                    {/* Sobreposição segue o título de Dialog (DialogTitle): h6 na cor de texto. */}
                    <Typography component="h2" variant="h6">{titulo}</Typography>
                    {descricao && (
                        <Typography variant="body2" color="textSecondary">{descricao}</Typography>
                    )}
                </div>
                <IconButton aria-label="Fechar" title="Fechar" onClick={onFechar}>
                    <Close />
                </IconButton>
            </div>

            <List className={classes.lista}>
                {acoes.map((acao, indice) => (
                    <React.Fragment key={acao.id}>
                        {indice === 0 && <Divider />}
                        <ListItem button className={classes.item} onClick={acao.onClick}>
                            <ListItemIcon className={classes.icone}>{acao.icone}</ListItemIcon>
                            <ListItemText
                                primary={acao.titulo}
                                secondary={acao.descricao}
                                secondaryTypographyProps={{
                                    className: acao.contador > 0 ? classes.descricaoAviso : undefined
                                }}
                            />
                            {acao.contador > 0 && (
                                <Chip
                                    size="small"
                                    label={acao.contador}
                                    className={classes.contador}
                                />
                            )}
                            <ChevronRight className={classes.seta} />
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                ))}
            </List>

            <div className={classes.rodape}>
                <TextButton fullWidth startIcon={<Close />} onClick={onFechar}>
                    Fechar
                </TextButton>
            </div>
        </SwipeableDrawer>
    );
}

SheetAcoesInscricao.propTypes = {
    aberto: PropTypes.bool,
    onFechar: PropTypes.func.isRequired,
    onAbrir: PropTypes.func,
    titulo: PropTypes.string,
    descricao: PropTypes.string,
    acoes: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        icone: PropTypes.node,
        titulo: PropTypes.string.isRequired,
        descricao: PropTypes.string,
        contador: PropTypes.number,
        onClick: PropTypes.func
    }))
};
